import {ChartOptions} from "../../../../actions/queryBuilderApi";
import {ReactECharts} from "../../../../components/charts/ReactECharts";
import React from "react";
import {stackedBarChartOption} from "./stackedBarChartOption";
import {useChartDataFetcher} from "./chartDataFetcher";
import {bubbleSortStack} from "./ChartUtil";

export type StackedBarChartProps = {
    chartOptions: ChartOptions
}

export const StackedBarChart = ({chartOptions}: StackedBarChartProps) => {
    const chartData = useChartDataFetcher(chartOptions)
    if (chartData.values.length > 0) {
        bubbleSortStack(chartData, chartOptions.sort)
    }

    if (chartOptions.sort !== 0 && chartOptions.topTen) {
        chartData
            .values
            .map(i => i.data.splice(10, i.data.length - 10))
        chartData.labels.splice(10, chartData.labels.length - 10)
    }

    const stackedBarChartOptions = stackedBarChartOption(chartData)
    return <ReactECharts option={stackedBarChartOptions} settings={{notMerge: true}}/>
}